import { Button } from "@newsela/angelou";
import PropTypes from "prop-types";

import {
  withTrackEvent,
  objectTypes,
  actionPrefixes,
  actionNames,
} from "@newsela/snitch";
import { buttonCss } from "./QuizToggleAnswersButton.style.js";

const propTypes = {
  handleOnClick: PropTypes.func,
  showAnswersInPresentMode: PropTypes.bool,
  contentId: PropTypes.string,
  questionId: PropTypes.string,
};

const ButtonWithTrackEvent = withTrackEvent(Button);

const QuizToggleAnswersButton = ({
  handleOnClick,
  showAnswersInPresentMode,
  questionId,
  contentId,
}) => {
  const showHideAnswersButtonEventProperties = {
    objectType: objectTypes.quizQuestion,
    actionPrefix: showAnswersInPresentMode
      ? actionPrefixes.initiate
      : actionPrefixes.cancel,
    actionName: actionNames.hide,
    streamProperties: {
      content_type: "Article",
      description: `${showAnswersInPresentMode ? "Hide" : "Show"} answers in present mode`,
      content_id: contentId,
      object_id: questionId,
    },
  };

  return (
    <ButtonWithTrackEvent
      {...showHideAnswersButtonEventProperties}
      __cssFor={{ root: buttonCss }}
      dataProps={{
        "data-qa-selector": "quiz-toggle-answer-button",
      }}
      flavor={Button.flavors.secondary}
      isFullWidth
      onClick={handleOnClick}
    >
      {showAnswersInPresentMode ? "Hide answer" : "Show answer"}
    </ButtonWithTrackEvent>
  );
};

QuizToggleAnswersButton.propTypes = propTypes;

export default QuizToggleAnswersButton;
